module.exports = __webpack_public_path__ + "img/icon_artmedia.aa488da.svg";